document.addEventListener('DOMContentLoaded', function () {

    const radios = document.querySelectorAll('.accordion-bral .ac-input[type="radio"]');
    let lastChecked = null;

    radios.forEach(function (radio) {

        radio.addEventListener('click', function () {

            const clickedRadio = this;

            if (lastChecked === clickedRadio) {
                clickedRadio.checked = false;
                lastChecked = null;
                return;
            }

            lastChecked = clickedRadio;

            setTimeout(function () {
                const label = document.querySelector('label[for="' + clickedRadio.id + '"]');

                if (label) {
                    const offset = 120; // increase/decrease if your sticky header covers it
                    const labelTop = label.getBoundingClientRect().top + window.pageYOffset;

                    window.scrollTo({
                        top: labelTop - offset,
                        behavior: 'smooth'
                    });
                }
            }, 400);

        });

    });

});